import React from 'react';
import { Paper, Typography } from '@mui/material';
import CompanyAppsStatusBoard from '../CompanyAppsStatusBoard';

export default function AppsHealthWidget({ userData }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Business operations app health
      </Typography>
      <CompanyAppsStatusBoard userData={userData} compact showHeader={false} />
    </Paper>
  );
}
